import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { Typography, makeStyles, Icon, Button, } from '@material-ui/core';
import clsx from 'clsx';
const useStyle = makeStyles((theme) => {
    return {
        root: {
            display: 'flex',
            alignItems: 'center',
            flexDirection: 'column',
            padding: theme.spacing(1),
            [theme.breakpoints.up('sm')]: {
                padding: theme.spacing(2),
            },
        },
        icon: {
            fontSize: '4em',
            marginBottom: theme.spacing(2),
            [theme.breakpoints.up('md')]: {
                fontSize: '6em',
            },
        },
        title: {
            marginBottom: theme.spacing(1),
            textAlign: 'center',
            fontSize: '1.5em',
            [theme.breakpoints.up('md')]: {
                fontSize: '2em',
            },
        },
        message: {
            textAlign: 'center',
            fontSize: '1em',
            [theme.breakpoints.up('md')]: {
                fontSize: '1.5em',
            },
        },
        action: {
            marginTop: theme.spacing(1),
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
            width: '100%',
            '& button': {
                fontSize: 'smaller',
            },
            [theme.breakpoints.up('md')]: {
                marginTop: theme.spacing(2),
                '& button': {
                    fontSize: 'unset',
                },
            },
        },
    };
}, {
    name: 'EmptyList',
});
/**
 * This Component can be used for showing a loading message.
 */
export const EmptyContentLoadingMessage = (props) => {
    const classes = useStyle();
    return (_jsxs("div", { className: clsx(classes.root, props.className), style: props.style, children: [_jsx(Icon, { className: classes.icon, color: props.color ? props.color : 'primary', children: props.icon ? props.icon : 'hourglass_empty' }), props.title
                && _jsx(Typography, { variant: "h4", color: "textPrimary", className: classes.title, children: props.title }), props.message
                && _jsx(Typography, { variant: "h5", color: "textPrimary", className: classes.message, children: props.message })] }));
};
/**
 * This Component can be used for showing an Empty list message. Whenever we have a page that display list of items and when we
 * have an empty list, we can use this to display a message to let the user know the list is empty.
 */
export const EmptyListMessage = (props) => {
    const classes = useStyle();
    return (_jsxs("div", { className: clsx(classes.root, props.className), style: props.style, children: [props.icon !== null && (_jsx(Icon, { className: classes.icon, color: props.color ? props.color : 'error', children: props.icon ? props.icon : 'sentiment_very_dissatisfied' })), props.title
                && _jsx(Typography, { variant: "h4", color: "textPrimary", className: classes.title, children: props.title }), props.message
                && _jsx(Typography, { variant: "h5", color: "textPrimary", className: classes.message, children: props.message }), props.action && props.actionHandler && (_jsx("div", { className: classes.action, children: _jsx(Button, { variant: "contained", color: props.actionColor ? props.actionColor : 'primary', onClick: props.actionHandler, children: props.action }) }))] }));
};
/**
 * This Component can be used for showing an Empty search result message. Whenever we have a page that let user search for items
 * and when the search return an empty result, we can use this to display a message to let the user know we can't find any item
 * the user is trying to search for.
 */
export const EmptySearchResultMessage = (props) => {
    const classes = useStyle();
    return (_jsxs("div", { className: clsx(classes.root, props.className), style: props.style, children: [_jsx(Icon, { className: classes.icon, color: props.color ? props.color : 'error', children: props.icon ? props.icon : 'find_in_page' }), props.title
                && _jsx(Typography, { variant: "h4", color: "textPrimary", className: classes.title, children: props.title }), props.message
                && _jsx(Typography, { variant: "h5", color: "textPrimary", className: classes.message, children: props.message }), props.action && props.actionHandler && (_jsx("div", { className: classes.action, children: _jsx(Button, { variant: "contained", color: "primary", onClick: props.actionHandler, children: props.action }) }))] }));
};
